const COMMENTS = [
  {
    id: 1,
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20portrait%20avatar%2C%20minimalist%20style%2C%20cream%20background%2C%20soft%20amber%20accents&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '一直在找能流畅看高清的免费平台，51影院真的没让我失望！画质清晰，加载速度也快，关键没有烦人的广告弹窗，观影体验太棒了。',
    time: '2天前',
  },
  {
    id: 2,
    name: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20portrait%20avatar%2C%20minimalist%20style%2C%20cream%20background%2C%20soft%20coral%20accents&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '每天更新速度真的快，院线新片几乎同步就有了。资源也很全，想看的电视剧基本都能找到，已经安利给身边所有朋友了！',
    time: '5天前',
  },
  {
    id: 3,
    name: '深夜刷剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20portrait%20avatar%2C%20minimalist%20style%2C%20cream%20background%2C%20soft%20golden%20accents&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '不用注册登录就能看这点太方便了，晚上躺床上打开就能看。画质选项也多，网速慢也能流畅播放，真心推荐。',
    time: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              用户好评
            </h2>
            <p className="text-sm text-foreground-600">来自真实影迷的使用反馈</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {COMMENTS.map((comment) => (
              <div
                key={comment.id}
                className="bg-background-50 border border-background-200 rounded-xl p-5"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">
                      {comment.name}
                    </div>
                    <div className="text-xs text-foreground-500">{comment.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {comment.text}
                </p>
                <div className="flex items-center gap-0.5 mt-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span key={star} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-xs text-accent-500"></i>
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}